/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     费用中心-客户发票 API 接口
  | @Version:   2018-12-25  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function getInvoiceDetailApi() {
  return request({
    url: '?c=expense&a=god-invoice&do=get',
    method: 'get'
  })
}

export function postInvoiceDetailApi(formData) {
  return request({
    url: generalApiHost + '/expense/invoice/post',
    method: 'post',
    data: formData
  })
}
